import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getAudiences } from "api/AudienceApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setCampaignAudienceName,
  setCampaignAudienceId,
  setComplaiceStatus,
} from "ReduxStore/Slices/campaignSlice";

export default function CampaignSelectAudience() {
  const [campaignAudienceList, setCampaignAudienceList] = useState([
    { label: "Please Select", value: "" },
  ]);
  const { campaignAudienceId, campaignAudienceName, campaignViewMode } = useSelector(
    (state) => state.campaignSetter
  );
  const dispatch = useDispatch();

  useEffect(() => {
    let audi = [];
    var i = 0;
    getAudiences()
      .then((data) => {
        data.map((aud) => {
          if (campaignAudienceId === aud.id) {
            dispatch(setCampaignAudienceName(aud.name));
          }
          i++;
          audi.push({
            label: aud.name,
            value: aud.id,
          });

          if (data.length === i) {
            setCampaignAudienceList(audi);
          }
        });
      })
      .catch((e) => { });
  }, [campaignAudienceId, campaignAudienceName]);

  return (
    <div className="row justify-content-between align-items-end pt_15">
      <div className="left_sec">
        <div className="max534">
          <label>Select Audience</label>
          <p className="campaign_text">Select recipients to send the email</p>
        </div>
      </div>
      <div className="right_sec">
        <div style={{ width: 400, height: 50 }}>
          <Select
            id="audId"
            isClearable
            value={{
              value: campaignAudienceId,
              label: campaignAudienceName,
            }}
            onChange={(e, { action }) => {
              dispatch(setCampaignAudienceId(null));
              dispatch(setCampaignAudienceName(null));
              if (action == "clear") {
                sessionStorage.setItem("campaignAudienceId", null);
                sessionStorage.setItem("campaignAudienceName", null);
              }
              if (e !== null) {
                sessionStorage.setItem("campaignAudienceId", e.value);
                sessionStorage.setItem("campaignAudienceName", e.label);
                dispatch(setCampaignAudienceId(e.value));
                dispatch(setCampaignAudienceName(e.label));
              }
              dispatch(setComplaiceStatus("Editing"));
            }}
            options={campaignAudienceList}
            required
            isDisabled={campaignViewMode}
          />
          <input
            tabIndex={-1}
            autoComplete="off"
            style={{ opacity: 0, height: 0 }}
            required={!campaignAudienceName}
            id="tt"
          />
        </div>
      </div>
    </div>
  );
}
